<template>
  <div class="app-person">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

    <div
      v-for="(_, i) in valueLocal"
      :key="`input-group-${i}`"
      class="input-group">

      <el-switch v-if="!options.OnlyUsers"
        v-model="valueLocal[i].notRegistered"
        @change="resetValue(i)"
        class="switch-type"
        active-color="#fff"
        inactive-color="#fff"
        active-text="Не зарегистрирован"
        inactive-text="Зарегистрирован"/>

      <div v-if="options.stake"
        class="stake required">
        <span class="input-subtitle">Авторский вклад</span>
        <el-input-number
          v-model="valueLocal[i].stake"
          controls-position="right"
          @change="onStakeChange()"
          :min="1"
          :max="maxStake"/>
        <div class="stake-sum"> из {{ stakeSum }}</div>
        <el-tooltip :content="'Общее число долей авторского вклада'" placement="top">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>

      <div class="cols">
        <template v-if="valueLocal[i].notRegistered">

          <div class="col">
            <div class="input-subtitle" :class="{ required: options.required }">Фамилия</div>
            <el-input
              v-model="valueLocal[i].surname"
              :class="{ 'child-has-error': error[i].extSurname }"
              @focus="clearError('extSurname', i)"
              :key="'surname-' + i"/>
          </div>
          <div class="col">
            <div class="input-subtitle" :class="{ required: options.required }">Имя</div>
            <el-input
              v-model="valueLocal[i].name"
              :class="{ 'child-has-error': error[i].extName }"
              @focus="clearError('extName', i)"
              :key="'name-' + i"/>
          </div>
          <div class="col">
            <div class="input-subtitle">Отчество</div>
            <el-input v-model="valueLocal[i].patronymic" :key="'patronymic-' + i"/>
          </div>
          <div class="col2">
            <div class="input-subtitle" :class="{ required: options.required }">
              Электронная почта
            </div>
            <el-input
            v-model="valueLocal[i].mail"
            :class="{ 'child-has-error': error[i].extMail }"
            @focus="clearError('extMail', i)"
            :key="'mail-' + i"/>
          </div>
          <div class="col2">
            <div class="input-subtitle">Номер телефона</div>
            <el-select
              v-model="valueLocal[i].code"
              placeholder="Выберите"
              clearable
              filterable
              class="phone_code">
              <el-option
                v-for="item in codes"
                :key="`${item.code}-${item.country}`"
                :value="item.code">
                <span>{{ item.code }} &nbsp; {{ item.country }}</span>
              </el-option>
            </el-select>
            <masked-input
              v-model="valueLocal[i].number"
              type="text"
              :key="'phone-' + i"
              class="input-base-style phone_number"
              :mask="[
                /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-',
                /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/
              ]"
              :guide="false"
              :showMask="false"
              placeholder="Номер телефона"/>

          </div>
          <div class="col2">
            <div class="input-subtitle">Организация</div>
            <el-select
              v-model="valueLocal[i].organizationId"
              :key="`organization-id-${i}`"
              :class="{ 'child-has-error': error[i].extOrganization }"
              @focus="clearError('extOrganization', i)"
              filterable
              clearable
              placeholder="Выберите организацию"
              style="width: 100%;"
              @input="onOrganizationIdChanged(i)"
              v-bind="widgetOptions">
              <el-option
                v-for="(o, j) in organizations"
                :key="`organization-id-option-${j}`"
                :label="o.label"
                :value="o.value">
              </el-option>
            </el-select>

          </div>
          <div class="col2">
            <div class="input-subtitle">Должность</div>
            <el-input
            v-model="valueLocal[i].post"
            :key="'post-' + i"/>
          </div>
          <template v-if="valueLocal[i].organizationId === 'other'">
            <div class="col1">
              <div class="input-subtitle input-organization-name">
                Название организации</div>
              <el-input
                v-model="valueLocal[i].organization"
                @focus="clearError('extOrganization', i)"
                :class="{ 'child-has-error': error[i].extOrganization }"
                :key="`organization-${i}`"/>
            </div>
          </template>
          <div v-if="error[i].extName" class="ait_message ait_message--error">
            {{ error[i].extName }}
          </div>
          <div v-if="error[i].extSurname" class="ait_message ait_message--error">
            {{ error[i].extSurname }}
            </div>
          <div v-if="error[i].extMail" class="ait_message ait_message--error">
            {{ error[i].extMail }}
          </div>
          <div v-if="error[i].extOrganization" class="ait_message ait_message--error">
            {{ error[i].extOrganization }}
          </div>
        </template>
        <template v-else>

          <div class="col-wide">
            <div class="input-subtitle">Пользователь</div>
            <el-select
              v-model="valueLocal[i].userId"
              :key="`person-userId-${i}`"
              :class="{ 'child-has-error': error[i].emptyId }"
              filterable
              remote
              clearable
              style="width: 100%"
              :remote-method="getSuggestions"
              @focus="curIndex = i, clearError('emptyId', i)"
              @change="onUserIdChange(i)"
              placeholder="Введите Ф.И.О. пользователя"
              v-bind="widgetOptions"
              :loading="loading">
              <el-option
                v-for="(s, j) in suggestions[i]"
                :key="`person-userId-option-${i}-${j}`"
                :label="s.fio"
                :value="s.userId">
                <div v-if="s.fio" class="fio">{{ s.fio }}</div>
                <div v-if="s.organization" class="organization">{{ s.organization }}</div>
              </el-option>
            </el-select>
          </div>
          <div v-if="error[i].emptyId" class="ait_message ait_message--error">
            {{ error[i].emptyId }}
          </div>
        </template>
        <el-checkbox
          v-if="copyrightHolder"
          class="copyright-holder"
          v-model="valueLocal[i].IsCopyrightHolder">
            Является правообладателем (в соответствии с ч. IV ГК РФ)
        </el-checkbox>
      </div>
    </div>
    </div>
    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import MaskedInput from 'vue-text-mask';
import axios from 'axios';
import Common from './mixins/Common';
import codes from '../../../data/country-phone-codes';

export default {

  components: {
    MaskedInput,
  },

  mixins: [Common],

  data() {
    return {
      valueBase: {
        surname: '',
        name: '',
        patronymic: '',
        notRegistered: false,
        userId: '',
        stake: '',
        code: '+7',
        number: '',
        IsCopyrightHolder: true,
      },
      errorBase: { emptyId: '', extMail: '', extName: '', extSurname: '', extOrganization: '' },
      curIndex: 0,
      loading: false,
      suggestions: [],
      stakeSum: 1,
      organizations: [],
      codes,
    };
  },

  watch: {
    valueLocal: {
      handler() {
        this.$nextTick(() => { this.onStakeChange(); });
      },
      deep: true,
    },
  },


  created() {
    // Add error messages
    this.error.push(this.errorBase);
    this.validateMessages = Object.assign(
      this.validateMessages, {
        extMail: 'Введите корректный адрес электронной почты!',
        extSurname: 'Заполните фамилию не зарегистрированного пользователя!',
        extName: 'Заполните имя не зарегистрированного пользователя!',
        extOrganization: 'Заполните организацию не зарегистрированного пользователя!',
      },
    );

    if (this.suggestions.length === 0
      && (this.options.name === 'Authors' || this.options.name === 'Contacts')
      && !this.options.EditMode) {
      const curUserId = this.$store.getters['user/getUserId'];
      if (curUserId) {
        axios.get(`users/${curUserId}`).then((response) => {
          const user = response.data;
          this.suggestions[this.curIndex] = [];
          this.suggestions[this.curIndex][0] = {};
          this.suggestions[this.curIndex][0].fioObj = {};
          this.valueLocal[0].userId = curUserId;
          this.suggestions[this.curIndex][0].userId = curUserId;
          this.valueLocal[0].surname = user.Surname;
          this.suggestions[this.curIndex][0].fioObj.surname = user.Surname;
          this.valueLocal[0].name = user.Name;
          this.suggestions[this.curIndex][0].fioObj.name = user.Name;
          this.valueLocal[0].patronymic = user.Patronymic;
          this.suggestions[this.curIndex][0].fioObj.patronymic = user.Patronymic;
          this.suggestions[this.curIndex][0].fio = [user.Surname, user.Name, user.Patronymic].join(' ');
          if (user.Jobs[0].Organization) {
            this.suggestions[this.curIndex][0].organization = user.Jobs[0].Organization;
          }
          if (user.Jobs[0].Department) {
            this.suggestions[this.curIndex][0].organization += `, ${user.Jobs[0].Department}`;
          }
          this.$forceUpdate();
        });
      }
    }

    axios.get('organizations').then((res) => {
      res.data.forEach((el) => {
        const OrganizationId = el.OrganizationId;
        const Organization = el.Name;
        this.organizations.push({
          value: OrganizationId,
          label: Organization,
        });
      });
      this.organizations.unshift({
        value: 'other',
        label: 'Другая организация',
      });
    });
  },

  computed: {
    maxStake() {
      if (this.valueLocal.length === 1) { return 1; }
      return 100;
    },

    copyrightHolder() {
      if (this.options.name === 'Authors') return true;
      return false;
    },
  },

  methods: {

    resetValue(i) {
      this.valueLocal[i].surname = '';
      this.valueLocal[i].name = '';
      this.valueLocal[i].patronymic = '';
      this.valueLocal[i].userId = '';
      this.valueLocal[i].code = '+7';
      this.valueLocal[i].number = '';
      this.$set(this.valueLocal[i], 'organization', '');
      this.$set(this.valueLocal[i], 'mail', '');
      this.$set(this.valueLocal[i], 'post', '');
      this.valueLocal[i].organizationId = '';
      this.valueLocal[i].IsCopyrightHolder = true;
    },

    setValue(value) {
      this.valueLocal = [];
      this.suggestions = [];
      value.forEach((v, i) => {
        const phone = v.Phone ? v.Phone.split(' ') : [];
        let affiliations = {};
        if (!v.UserId && v.Affiliations && v.Affiliations.length > 0) {
          affiliations = v.Affiliations[0];
        }
        this.valueLocal.push({
          name: v.Name,
          surname: v.Surname,
          patronymic: v.Patronymic,
          userId: v.UserId,
          stake: v.Stake,
          notRegistered: v.UserId === '',
          organizationId: (affiliations.Organization && !affiliations.OrganizationId) ? 'other' : affiliations.OrganizationId,
          organization: affiliations.Organization,
          post: affiliations.Post,
          mail: v.Mail,
          code: phone[0] ? phone[0] : this.valueBase.code,
          number: phone[1] ? phone[1] : '',
          IsCopyrightHolder: v.IsCopyrightHolder,
        });
        this.suggestions.push([]);
        this.error[i] = this.errorBase;
        if (this.valueLocal[i].notRegistered === false) {
          const fio = [this.valueLocal[i].surname, this.valueLocal[i].name,
            this.valueLocal[i].patronymic].join(' ');
          const suggestion = { fio, userId: this.valueLocal[i].userId };
          this.suggestions[i].push(suggestion);
          axios.get(`users/${this.valueLocal[i].userId}/profile`).then((r) => {
            if (r.data && r.data.Jobs && r.data.Jobs.length && r.data.Jobs[0].Organization) {
              suggestion.organization = r.data.Jobs[0].Organization;
              this.$forceUpdate();
            }
          });
        }
      });
      this.$forceUpdate();
    },

    getSuggestions(query) {
      if (query !== '') {
        this.loading = true;
        axios.get('users/search', { params: { fio: query } }).then((response) => {
          this.loading = false;
          this.suggestions[this.curIndex] = [];
          response.data.Users.forEach((user, i) => {
            this.suggestions[this.curIndex][i] = {};
            this.suggestions[this.curIndex][i].userId = user.UserId;

            this.suggestions[this.curIndex][i].fioObj = {};
            this.suggestions[this.curIndex][i].fioArr = [];
            if (user.Surname) {
              this.suggestions[this.curIndex][i].fioObj.surname = user.Surname;
              this.suggestions[this.curIndex][i].fioArr.push(user.Surname);
            }
            if (user.Name) {
              this.suggestions[this.curIndex][i].fioObj.name = user.Name;
              this.suggestions[this.curIndex][i].fioArr.push(user.Name);
            }
            if (user.Patronymic) {
              this.suggestions[this.curIndex][i].fioObj.patronymic = user.Patronymic;
              this.suggestions[this.curIndex][i].fioArr.push(user.Patronymic);
            }
            this.suggestions[this.curIndex][i].fio = this.suggestions[this.curIndex][i].fioArr.join(' ');
            delete this.suggestions[this.curIndex][i].fioArr;
            if (user.Jobs) {
              if (user.Jobs[0].Organization) {
                this.suggestions[this.curIndex][i].organization = user.Jobs[0].Organization;
              }
              if (user.Jobs[0].Department) {
                this.suggestions[this.curIndex][i].organization += `, ${user.Jobs[0].Department}`;
              }
            } else {
              this.suggestions[this.curIndex][i].organization = '';
            }
          });
        });
      }
    },

    // Return errors array for all fields
    getError() {
      // Validate if required
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          this.error[i] = { emptyId: '', extMail: '', extName: '', extSurname: '', extOrganization: '' };
          if (el.notRegistered) {
            if (!el.surname) { this.error[i].extSurname = this.validateMessages.extSurname; }
            if (!el.name) { this.error[i].extName = this.validateMessages.extName; }
            if (!el.mail) {
              this.error[i].extMail = this.validateMessages.extMail;
            } else {
              const checkExtMail = approve.value(el.mail, { email: true });
              this.error[i].extMail = checkExtMail.approved ? '' : this.validateMessages.extMail;
            }
            if (el.post && !el.organization && (!el.organizationId || el.organizationId === 'other')) {
              this.error[i].extOrganization = this.validateMessages.extOrganization;
            }
          } else if (!el.userId) {
            this.error[i].emptyId = this.validateMessages.required;
          }
        });
      }
      this.updateValue();
      return this.error;
    },

    clearError(elName, i) {
      if (this.error[i][elName]) {
        this.error[i][elName] = '';
        this.$forceUpdate();
      }
    },

    onUserIdChange(i) {
      const s = this.suggestions[i];
      for (let j = 0; j < s.length; j += 1) {
        if (s[j].userId === this.valueLocal[i].userId) {
          if (s[j].fioObj.surname) this.valueLocal[i].surname = s[j].fioObj.surname;
          if (s[j].fioObj.name) this.valueLocal[i].name = s[j].fioObj.name;
          if (s[j].fioObj.patronymic) this.valueLocal[i].patronymic = s[j].fioObj.patronymic;
          if (s[j].userId) this.valueLocal[i].userId = s[j].userId;
          break;
        }
      }
      this.$forceUpdate();
    },

    getValue() {
      const vl = this.valueLocal;
      const r = [];
      vl.forEach((v) => {
        if (v.surname || v.name || v.patronymic || v.userId) {
          let affiliations = {};
          let phone = '';
          if (v.notRegistered) {
            if (v.organization || v.organizationId || v.post) {
              affiliations = { OrganizationId: (v.organizationId && v.organizationId !== 'other') ? v.organizationId : '', Organization: v.organization ? v.organization : '', Post: v.post ? v.post : '' };
            }
            if (v.code && v.number) {
              phone = v.number.replace(/-/g, '');
              phone = `${v.code} ${phone}`;
            }
          }
          r.push({
            Surname: v.surname,
            Name: v.name,
            Patronymic: v.patronymic,
            UserId: v.notRegistered ? '' : v.userId,
            Affiliations: affiliations,
            Stake: v.stake,
            Mail: v.notRegistered ? v.mail : '',
            Phone: phone,
            IsCopyrightHolder: v.IsCopyrightHolder,
          });
        }
      });
      if (this.options && this.options.multiple) {
        return r;
      }
      return r.length ? r[0] : null;
    },

    onStakeChange() {
      this.stakeSum = 0;
      this.valueLocal.forEach((value) => {
        this.stakeSum += value.stake;
      });
    },

    onOrganizationIdChanged(i) {
      const orgId = this.valueLocal[i].organizationId;
      if (orgId === 'other') {
        this.valueLocal[i].organization = '';
      } else {
        this.organizations.forEach((orgData) => {
          if (orgData.value === orgId) {
            this.valueLocal[i].organization = orgData.label;
          }
        });
      }
      this.$forceUpdate();
    },

  },

};
</script>

<style lang="scss" scoped>
@import '../../../styles/common/main';
.app-person {
  .input-group {
    border-bottom: 1px dotted rgba(255, 255, 255, .3);
    padding-bottom: 32px;
    &:last-of-type {
      border-bottom: none!important;
      padding-bottom: 20px;
    }
  }
  .copyright-holder {
    padding-left: 10px;
  }
}
.switch-type {
  margin: 20px 0;
}
.cols {
  padding: 0;
  margin: -10px;
  clear: both;
  @include clearfix;
}
.col {
  float: left;
  width: 33.3333333%;
  padding: 10px;
}
.col1 {
  width: 100%;
  padding: 10px;
}
.col2 {
  padding: 10px;
  width: 50%;
  float: left;
  .input-organization-name {
    margin-top: 15px;
  }
  .phone_code {
    width: 25%;
  }
  .phone_number {
    width: 74%;
  }
}
.col-wide {
  padding: 10px;
}
.stake {
  float: right;
  padding-top: 10px;
  vertical-align: bottom;
  .el-icon-question {
    color: #ededed;
  }
  .el-input-number {
    width: 90px;
  }
  .input-subtitle {
    margin-right: 10px;
  }
  .stake-sum {
    margin-left: 10px;
    color: #dcdcdc;
    display: inline-block;
    width: 50px;
  }
}
@media (max-width: 730px) {
  .el-switch.switch-type {
    margin: 0 auto 10px;
    display: inline-block;
    text-align: center;
    width: 100%;
    height: auto;
  }
  .stake {
    float: none;
    margin-bottom: 15px;
    text-align: center;
    .el-input-number {
      width: 100%;
    }
    .input-subtitle {
      display: block;
      float: left;
      margin-bottom: 10px;
    }
  }
  .cols {
    .col {
      width: 100%;
    }
    .col2 {
      width: 100%
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppPerson.vue